import { ReimbursementType } from '../ReimbursementType.enum'

function getLabel(val: ReimbursementType) {
  switch (val) {
    case ReimbursementType.CONSULTATION:
      return 'Consultation'
    case ReimbursementType.MEDICATION:
      return 'Medication'
    case ReimbursementType.HOSPITALIZATION:
      return 'Hospitalization'
    case ReimbursementType.DIAGNOSTIC_TEST:
      return 'Diagnostic Test'
    case ReimbursementType.DENTAL:
      return 'Dental'
    case ReimbursementType.VISION:
      return 'Vision'
    case ReimbursementType.OTHER:
      return 'Other'
    default:
      return ''
  }
}

const ReimbursementTypeEnumHelper = {
  getLabel,
}

export default ReimbursementTypeEnumHelper
